export const getVidyardVideoId = (url: string) => {
  const regex = /\/watch\/([^/?]+)/;
  const match = url.match(regex);
  return match && match[1] ? match[1].replace(/\.jpg$/, "") : null;
};
